export default "__VITE_ASSET__ec19a25f__"